<template>
  <div>
    <h1>{{$route.meta.title}}</h1>
    <!-- Choix des paramètres -->
    <div class="form-container">
      <div class="row">
        <!-- Année -->
        <div class="col">
          <label>Année : </label>
          <input type="number" name="year" value="2022" class="form-control" v-model="year"/>
        </div>
        <!-- Top -->
        <div class="col">
          <label>Top : </label>
          <input type="number" name="top" value="300" class="form-control" v-model="top"/>
        </div>
        <!-- Validation -->
        <div class="col">
          <label> </label>
          <input class="btn bg-cmem form-control" type="button" value="Afficher" v-on:click="loadDatas()"/>
        </div>
      </div>
    </div>

    <br />

    <!-- Résultas -->
    <table class="table table-bordered table-striped" v-if="alerts.length > 0">
      <thead>
        <tr>
          <th>Top</th>
          <th>Code Compta</th>
          <th>Code Intranet</th>
          <th>Fournisseur</th>
          <th>Famille</th>
          <th>CDM</th>
          <th>Ecart Tx</th>
          <th>Commentaire</th>
          <th>Date Commentaire</th>
          <th>Visé ?</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="alert in alerts">
          <td>{{ alert.SupplierTop }}</td>
          <td>{{ alert.Frs_CodeCompta }}</td>
          <td>{{ alert.Frs_CodeIntra }}</td>
          <td>{{ alert.Frs_Nom }}</td>
          <td>{{ alert.Frs_CodeFamille }}</td>
          <td>{{ alert.CDM }}</td>
          <td class="red">{{ formatNbPercent(alert.TxTotN - alert.TxTotN1) }}</td>
          <td><textarea class="form-control" v-model="alert.Commentaire"></textarea></td>
          <td>{{ formatDate(alert.DateCommentaire) }}</td>
          <td><input type="checkbox"  v-model="alert.Visa" /></td>
          <td><button class="btn btn-success" v-on:click="saveDatas(alert.Frs_Guid, alert.Commentaire, alert.Visa)">Save</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { getAlerts, postCommentaire } from "@/utils/caRfa";
  import { getAllPeriods } from "@/utils/period";

  export default {
    name: "AlerteTxRfa",
    components: {  },
    data() {
      return {
        year: new Date().getFullYear() - 1,
        top: 300,
        alerts: [],
        periodId: 0
      }
    },
    mounted() {

    },
    watch: {
      
    },
    methods: {
      // Chargement des données
      loadDatas() {
        this.alerts = [];

        // On récupère les alertes stockées en base
        getAlerts(this.year, this.top).then(datas => {
          this.alerts = datas;
        });

        // Périodes pour lier l'année à l'id de l'annuelle
        getAllPeriods().then(r => {
          let period_o = r.find(e => e.annee == this.year && e.label == "Déclaration annuelle");
          if (period_o != undefined) {
            this.periodId = period_o.periodId;
          }
        })
      },

      // Enregistrement de la ligne
      saveDatas(supplierGuid, commentaire, visa) {
        if (this.periodId == 0) {
          alert("La période n'est pas correcte !");
        }
        else {
          postCommentaire(
            commentaire == null ? "" : commentaire,
            supplierGuid,
            visa == null ? 0 : visa,
            this.periodId);
        }

        this.loadDatas();
      },

      // Format en pourcentage
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },

      // Format date
      formatDate(n) {
        if (n == null || n == "") {
          return "";
        }
        return new Date(n).toLocaleString("fr-FR");
      }
    },
  }
</script>

<style scoped>
  .form-container {
      max-width: 30%;
  }

  .bg-cmem {
      background: #A7c13c;
      color: #FFFFFF;
  }

  .red {
      color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/RFA/AlerteTxRfa.vue